import { render } from "./PremiumForm.vue?vue&type=template&id=e2dad5d6"
import script from "./PremiumForm.vue?vue&type=script&lang=js"
export * from "./PremiumForm.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__